import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';

export interface CardButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children' | 'title'> {
  icon?: ReactNode;
  title: ReactNode;
  meta?: ReactNode;
  trailing?: ReactNode;
  active?: boolean;
  variant?: 'card' | 'nav';
  className?: string;
  ref?: Ref<HTMLButtonElement>;
}

export function CardButton(props: CardButtonProps): ReactNode {
  const {
    icon,
    title,
    meta,
    trailing,
    active = false,
    variant = 'card',
    className,
    ref,
    type,
    ...rest
  } = props;
  const classes = [
    'vq-card-button',
    `vq-card-button--${variant}`,
    active ? 'vq-card-button--active' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={classes}
      data-component="CardButton"
      data-active={active ? 'true' : undefined}
      aria-current={active ? 'page' : undefined}
      {...rest}
    >
      {icon !== undefined ? (
        <span aria-hidden className="vq-card-button__icon">
          {icon}
        </span>
      ) : null}
      <span className="vq-card-button__text">
        <span className="vq-card-button__title">{title}</span>
        {meta !== undefined ? (
          <span className="vq-card-button__meta">{meta}</span>
        ) : null}
      </span>
      {trailing !== undefined ? (
        <span className="vq-card-button__trailing">{trailing}</span>
      ) : null}
    </button>
  );
}
